import React from 'react';
import { Field } from 'redux-form';
import { FormControlLabel, Radio } from '@material-ui/core';
import styled from 'styled-components';
import { required } from '../../../../utils/validators';
import InlineFormRadioGroup from "./InlineFormRadioGroup";

const StyledInlineFormRadioGroup = styled(InlineFormRadioGroup)`
  label:last-child {
    margin-left: 30px;
  }
`;

const DocumentsUploadMethodPicker = () => (
  <>
    <Field
      name="documents_upload_method"
      component={StyledInlineFormRadioGroup}
      row
      validate={required}
    >
      <FormControlLabel
        value="upload"
        control={<Radio color="primary" />}
        label="Upload documents now"
        error
      />
      <FormControlLabel
        value="email"
        control={<Radio color="primary" />}
        label="Send documents via Email"
      />
    </Field>
  </>
);

export default DocumentsUploadMethodPicker;
